import { Collapse, Divider } from '@chakra-ui/react';
import { Body, Box, Stack } from '@hover/blueprint';
import React from 'react';
import { INavbarItem } from '../../../interfaces/INavbarItems';
import NavbarMobileLink from './NavbarMobileLink';

interface IMobileNavbarItem extends INavbarItem {
  isOpen: boolean;
  onToggle: () => void;
}

const NavbarMobileItem = ({
  label,
  children,
  to,
  isOpen,
  onToggle,
}: IMobileNavbarItem) => (
  <Stack>
    <NavbarMobileLink
      label={label}
      to={to}
      _hover={{
        textDecoration: 'none',
      }}
      color={isOpen ? 'primary.600' : 'neutral.700'}
      onClick={() => {
        if (onToggle) onToggle();
      }}
      isBold
    />

    <Collapse in={isOpen}>
      <Stack px={400} borderStyle="solid" borderColor="black" align="start">
        {children?.map((child, index) =>
          child?.to ? (
            <NavbarMobileLink
              key={child.label}
              label={child.label}
              to={child.to}
              py={2}
            />
          ) : (
            <Stack
              spacing={400}
              pb={index === children.length - 1 ? 200 : 600}
              key={child.label}
            >
              <Body key={child.label} color="neutral.400" size={300}>
                {child.label}
              </Body>
              {child?.children?.map(item => (
                <NavbarMobileLink
                  to={item.to}
                  label={item.label}
                  key={item.label}
                />
              ))}
            </Stack>
          ),
        )}
      </Stack>
    </Collapse>
    <Box my={200} style={{ marginTop: '0!important' }}>
      <Divider
        color="primary.100"
        borderWidth="1px"
        orientation="horizontal"
        opacity={1}
      />
    </Box>
  </Stack>
);

export default NavbarMobileItem;
